import React from "react";
import { useFETCH } from "../../Tools/APIs";
import { Col } from "../../Tools/Grid-system";
import DataMapProUsers from "./DataMapProUsers";
import NavBarProUsers from "./NavBarProUsers";

const ProUsers = () => {
  const { data, isLoading } = useFETCH("v1/users/pro");

  return (
    <Col md={11} className="min-h-[50vh] mx-auto">
      <NavBarProUsers
        data={data?.data?.data}
        title="ProUsers"
        desc=""
      />
      <DataMapProUsers
        data={data?.data?.data}
        isLoading={isLoading}
      />
    </Col>
  );
};

export default ProUsers; 